var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-list-overview',{attrs:{"controller":"Child","filter":_vm.Filter,"redirect":"","redirect-page":"Children","tab":"children","visible":_vm.visible}})
}
var staticRenderFns = []

export { render, staticRenderFns }